<template>
  <q-card flat>
    <q-card-section class="no-padding">
      <q-banner class="bg-blue text-white">
        مدیریت پرسشنامه طرف معامله
      </q-banner>
    </q-card-section>
    <q-card-section>
      <QuestionnaireCU :actions="cuActions" :items="items"/>
    </q-card-section>
    <q-card-section>
      <QuestionnaireList :items="items"/>
    </q-card-section>
  </q-card>
</template>

<script>
import QuestionnaireCU from "@/components/CustomerQuestions/QuestionnaireCU";
import QuestionnaireList from "@/components/CustomerQuestions/QuestionnaireList";
import {mapActions} from "vuex";

export default {
  name: "Questionnaire",
  components: {QuestionnaireList, QuestionnaireCU},
  data() {
    return {
      items: [],
      cuActions: ''
    }
  },
  methods: {
    ...mapActions({
      questionCRUD: 'Questions/crudQuestion'
    })
  },
  created() {
    this.questionCRUD({action: 'select'}).then((res) => {
      res.forEach(record => this.items.push(record))
    })
  }
}
</script>

<style scoped>

</style>